module.exports = __webpack_public_path__ + "img/INF-B-2-II.58d82f8e.png";